﻿<!--<rdo-chart-export-buttons [config]="chartConfig" [topOffset]="'0px'"></rdo-chart-export-buttons>-->
<div [rdo-highcharts]="chartConfig" [useVendorExport]="false" [chartId]="chartId"></div>
